import React, {FC} from 'react'
import styled from 'styled-components'
import date_time_choice_wrapperStyles from './date_time_choice_wrapper.styles'

const apAtomName = {ap_atom_name: 'apDateTimeChoiceWrapperAtom'}

const StyledWrapper = styled(props => <div {...props} />)`
  ${date_time_choice_wrapperStyles}
`

const DateTimeChoiceWrapperAtom: FC<React.HTMLAttributes<HTMLDivElement>> =
  function (props) {
    return <StyledWrapper {...apAtomName} {...props} />
  }

export default DateTimeChoiceWrapperAtom
